import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";

@Component({
	selector: "app-about-me-egift-received",
	templateUrl: "./about-me-egift-received.component.html",
	styleUrls: ["../../../customer.scss"],
})
export class AboutMeEgiftReceivedComponent implements OnInit {
	loadedGiftBalanceData: boolean = false;
	constructor(public app: AppService, public customerService: CustomerService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.customerService.publicCustomer.subscribe((customer) => {
			if (!this.loadedGiftBalanceData && customer.giftCardsReceived && customer.giftCardsReceived.length > 0) {
				customer.giftCardsReceived.forEach((card) => {
					if (card.cardNumber) {
						this.getCardBalance(card.venueKey, card.cardNumber).then((data) => (card.currentBalance = data));
						card.balanceCheckCompleted = true;
					}

					if (!card.activated) {
						card.activationUrl = `https://app.focuspos.com/${card.venueKey}/gift/activate/${card.key}`;
					}
				});
				this.loadedGiftBalanceData = true;
			}
		});
	}

	async getCardBalance(venueKey: number, acctNo: string): Promise<number> {
		try {
			const resp = await this.focuslink.getGiftBalance(venueKey, acctNo);
			return resp.balance;
		} catch (error) {}
	}
}
